import { makeStyles, Typography } from "@material-ui/core"
import React from "react"
import { useRetrospectiva } from "../context/RetrospectivaContext"
import { ContainerInsta } from "./ContainerInsta"
import { pastelWavesSvg, sparklesSvg } from "./Svg"

const useStyles = makeStyles(() => ({
    vinheta: {
        position: "absolute",
        inset: 0 as any,
        background: "radial-gradient(120% 70% at 50% 80%, rgba(0,0,0,.35) 0%, rgba(0,0,0,0) 55%)",
        pointerEvents: "none" as any,
    },
    card: {
        position: "relative" as any,
        margin: "auto",
        width: "min(88%, 980px)",
        height: "86%",
        borderRadius: 36,
        border: "1px solid rgba(255,255,255,.35)",
        background: "rgba(255,255,255,.08)",
        boxShadow: "0 20px 60px rgba(0,0,0,.35), inset 0 1px 0 rgba(255,255,255,.2)",
        backdropFilter: "blur(14px)",
        WebkitBackdropFilter: "blur(14px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column" as any,
        padding: "48px 28px",
        zIndex: 2,
    },
    brilho: (props: { sparklesSvg: string }) => ({
        position: "absolute" as any,
        inset: 0 as any,
        backgroundImage: `url("data:image/svg+xml;utf8,${props.sparklesSvg}")`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        opacity: 0.6,
        pointerEvents: "none" as any,
        borderRadius: 36,
    }),
    avatarWrap: {
        position: "relative" as any,
        marginBottom: 18,
    },
    ring: {
        position: "absolute" as any,
        inset: -18,
        borderRadius: "50%",
        background: "conic-gradient(from 0deg, rgba(255,255,255,.5), rgba(255,255,255,0) 60%)",
        filter: "blur(8px)",
        animation: "$spin 8s linear infinite",
    },
    "@keyframes spin": {
        from: { transform: "rotate(0deg)" },
        to: { transform: "rotate(360deg)" },
    },
    avatar: {
        width: 112,
        height: 112,
        borderRadius: "50%",
        display: "grid",
        placeItems: "center",
        color: "#0f1426",
        fontWeight: 800,
        fontSize: 34,
        background: "rgba(255,255,255,0.94)",
        boxShadow: "0 18px 30px rgba(0,0,0,.25), inset 0 1px 0 rgba(255,255,255,.6)",
    },
    logoImg: {
        width: "100%",
        height: "100%",
        borderRadius: "100%",
    },
    titulo: {
        fontSize: 30,
        color: "white",
        fontWeight: 700,
        textShadow: "0px 6px 18px rgba(0,0,0,.5)",
        marginBottom: 6,
        textAlign: "center" as any,
    },
    subtitulo: {
        fontSize: "1.2rem",
        color: "white",
        fontWeight: 800,
        textShadow: "0px 10px 28px rgba(0,0,0,.6)",
        marginBottom: 18,
        textAlign: "center" as any,
    },
    chipsRow: {
        display: "flex",
        gap: 12,
        flexWrap: "wrap" as any,
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 26,
    },
    chip: {
        padding: "10px 16px",
        borderRadius: 999,
        border: "1px solid rgba(255,255,255,.45)",
        background: "rgba(255,255,255,.14)",
        color: "white",
        fontWeight: 600,
        fontSize: 14,
        boxShadow: "inset 0 1px 0 rgba(255,255,255,.25)",
    },
}))

export function Apresentacao() {
    const dadosRestrospectiva = useRetrospectiva()
    const gradiente = "linear-gradient(180deg, #99001f 0%, #c0003a 55%, #e0004e 100%)"
    const classes = useStyles({ sparklesSvg })

    return (
        <ContainerInsta img={pastelWavesSvg} gradiente={gradiente}>
            <div className={classes.vinheta} />

            <div className={classes.card}>
                <div className={classes.brilho as any} />

                <div className={classes.avatarWrap}>
                    <div className={classes.ring} />
                    <div className={classes.avatar}>
                        <img
                            src={dadosRestrospectiva?.estabelecimento.urlLogo}
                            className={classes.logoImg}
                        />
                    </div>
                </div>

                <Typography className={classes.titulo}>
                    Olá, {dadosRestrospectiva?.estabelecimento.nome}
                </Typography>

                <Typography className={classes.subtitulo}>
                    Sua retrospectiva 2025 chegou!
                </Typography>

                <div className={classes.chipsRow}>
                    <div className={classes.chip}>"Clientes fiéis crescendo"</div>
                </div>
            </div>
        </ContainerInsta>
    )
}
